<template>
  <div class="page-container">
    <div class="main">
      <page :url="url" :form="form" @reset @select-data="handleSelectionChange">
        <template slot="tableSearch">
          <el-form-item v-if="ROLE_TYPE.isManager()" :label="$t('text.agent')">
            <el-select v-model="form.agentId"
                       filterable
                       clearable
                       :placeholder="$t('message.chooseOne')"
                       popper-class="eloption">
              <el-option :label="$t('option.all')" value=""/>
              <el-option v-for="item in agentList"
                         :key="item.agentId"
                         :label="item.agentId + '-' + item.agentName"
                         :value="item.agentId"/>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('text.appId')">
            <el-select v-model="form.appId"
                       filterable
                       :placeholder="$t('message.chooseOne')"
                       popper-class="eloption">
              <el-option :label="$t('option.all')"
                         value=""/>
              <el-option v-for="merchant in merchantList"
                         :label="merchant.value + '-' + merchant.name"
                         :key="merchant.value"
                         :value="merchant.value"/>
            </el-select>
          </el-form-item>


          <el-form-item :label="$t('text.settlementCycle')">
            <el-select v-model="setSettlementCycleList" multiple>
              <el-option :label="$t('option.all')"
                         value="all"></el-option>
              <el-option :label="$t('settlementCycle.D0')"
                         value="D0"></el-option>
              <el-option :label="$t('settlementCycle.T1')"
                         value="T1"></el-option>
              <el-option :label="$t('settlementCycle.D0T1')"
                         value="D0T1"></el-option>
              <el-option :label="$t('settlementCycle.T2')"
                         value="T2"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item :label="$t('text.showPendingSettlement')">
            <el-select v-model="form.showWaitSettleAmount" style="width:80px" :placeholder="$t('text.no')">
              <el-option :label="$t('text.no')" value="00"></el-option>
              <el-option :label="$t('text.yes')" value="01"></el-option>
            </el-select>
          </el-form-item>
        </template>

        <template slot="buttonArea">
          <el-button type="primary" @click="add" size="small">
            {{ $t('text.addMerchant') }}
          </el-button>
          <el-button type="primary" :disabled="multipleSelection.length === 0" @click="editStatus" size="small" plain>
            {{ $t('text.batchEditMerchant') }}
          </el-button>
          <el-button type="primary" @click="reloadAllWaitSettleAmount" size="small">
            {{ $t('text.reloadWaitSettleAmount') }}
          </el-button>
        </template>

        <template slot="tableColumn">
          <el-table-column type="selection" width="50" align="center"></el-table-column>
          <el-table-column fixed prop="merchantName" width="150" :label="$t('text.merchantName')" align="center"/>
          <el-table-column prop="bdName" width="120" :label="$t('text.bdName')" align="center"/>
          <el-table-column prop="appId" width="180px" :label="$t('text.appId')" align="center"/>
          <el-table-column prop="agentName" width="150px" :label="$t('text.agentName')" align="center"/>
          <el-table-column prop="loginName" width="150px" :label="$t('text.loginName')" align="center"/>
          <el-table-column prop="merchantType" width="90px" :formatter="$formatter.formatMerchantType"
                           :label="$t('text.merchantType')" align="center"/>

          <el-table-column prop="" width="30px" label="|" align="center">|</el-table-column>

          <el-table-column prop="withdrawMinAmount" align="center" width="150px" :formatter="$formatter.FenToYuan3ToThousandth"
                           :label="$t('text.payoutMinAmount')"/>
          <el-table-column prop="withdrawMaxAmount" align="center" width="150px" :formatter="$formatter.FenToYuan3ToThousandth"
                           :label="$t('text.payoutMaxAmount')"/>
          <el-table-column prop="withdrawTelegramNotifyAmount" align="center" width="150px" :formatter="$formatter.FenToYuan3ToThousandth"
                           :label="$t('text.payoutNotifyAmount')"/>

          <el-table-column prop="" width="30px" label="|" align="center">|</el-table-column>

          <el-table-column prop="balance" align="center" width="150px" :formatter="$formatter.FenToYuan3ToThousandth"
                           :label="$t('text.balance')"/>
          <el-table-column prop="freezeBalance" width="100px" :formatter="$formatter.FenToYuanToThousandth"
                           :label="$t('text.frozenAmount')" align="center"/>
          <el-table-column prop="settlementCycle" width="90px" :label="$t('text.settlementCycle')" align="center"/>
          <el-table-column prop="waitSettleAmount" width="150px" :label="$t('text.pendingSettlement')" align="center">
            <template slot-scope="{ row }">
              <div v-if="row.waitSettleAmount"> {{ $formatter.FenToYuanToThousandth(null, null, row.waitSettleAmount, null) }}</div>
              <div v-else>--</div>
            </template>
          </el-table-column>
          <template v-if="this.$store.state.isPK">
            <el-table-column
              v-for="(value, key) in paymentTypes.PK.PAYMENT"
              width="120px"
              :label="$t(`text.collection${key}FeeRate`)"
              align="center"
              prop="paymentRateConfig"
            >
              <template slot-scope="scope">
                {{ JSON.parse(scope.row.paymentRateConfig || '{}')[value] || '' }}
              </template>
            </el-table-column>
            <el-table-column
              v-for="(value, key) in paymentTypes.PK.TRANSFER"
              width="120px"
              :label="$t(`text.disbursement${key}FeeRate`)"
              prop="transferRateConfig"
              align="center"
            >
              <template slot-scope="scope">
                {{ JSON.parse(scope.row.transferRateConfig || '{}')[value] || '' }}
              </template>
            </el-table-column>
          </template>
          <template v-else>
            <el-table-column
              v-for="(value, key) in paymentTypes.BD.PAYMENT"
              width="120px"
              prop="paymentRateConfig"
              :label="$t(`text.collection${key}FeeRate`)"
              align="center"
            >
              <template slot-scope="scope">
                {{ JSON.parse(scope.row.paymentRateConfig || '{}')[value] || '' }}
              </template>
            </el-table-column>
            <el-table-column
              v-for="(value, key) in paymentTypes.BD.TRANSFER"
              width="120px"
              prop="transferRateConfig"
              :label="$t(`text.disbursement${key}FeeRate`)"
              align="center"
            >
              <template slot-scope="scope">
                {{ JSON.parse(scope.row.transferRateConfig || '{}')[value] || '' }}
              </template>
            </el-table-column>
          </template>

          <el-table-column prop="" width="30px" label="|" align="center">|</el-table-column>

<!--          <el-table-column prop="openTieredBilling" width="110px" :formatter="$formatter.formatTieredBilling"-->
<!--                           :label="$t('text.tieredBilling')" align="center"/>-->
          <el-table-column prop="depositStatus" width="80px" :formatter="$formatter.formatCommonStatus"
                           :label="$t('text.collectionStatus')" align="center"/>
          <el-table-column prop="withdrawStatus" width="80px" :formatter="$formatter.formatCommonStatus"
                           :label="$t('text.disbursementStatus')" align="center"/>
          <el-table-column prop="riskFlag" width="80px" :formatter="$formatter.formatRiskFlag"
                           :label="$t('text.merchantRiskFlag')" align="center"/>
<!--          <el-table-column prop="rcsIp" width="340px" :label="$t('text.rcsIp')" align="center"/>-->
          <el-table-column prop="prodStatus" width="90px" :formatter="$formatter.formatProdStatus"
                           :label="$t('text.productionStatus')" align="center"/>
<!--          <el-table-column prop="notifyV2" width="100px" :formatter="$formatter.formatNotifyV2"-->
<!--                           :label="$t('text.notifyV2')" align="center"/>-->
          <el-table-column prop="createTime" width="160" :label="$t('text.creationTime')" align="center">
            <template slot-scope="{ row }">
              <div v-if="row.createDate"> {{
                  $formatter.formatDate(null, null, row.createDate + row.createTime, null)
                }}
              </div>
              <div v-else>--</div>
            </template>
          </el-table-column>
          <el-table-column fixed="right" :label="$t('text.actions')" :width="ROLE_TYPE.isManager() ? '330' : '80'" align="center">
            <template slot-scope="scope">
              <el-button type="primary" plain size="mini" v-if="ROLE_TYPE.isManager()"
                         @click="resendAddMerchantMail(scope.row)">
                {{ $t('text.resendAddMerchantMail') }}
              </el-button>
              <el-button type="primary" plain size="mini" v-if="ROLE_TYPE.isManager()"
                         @click="resetMerPass(scope.row)">
                {{ $t('text.resetPasswordAndGoogleAuthKey') }}
              </el-button>
              <el-button type="primary" plain size="mini" v-if="ROLE_TYPE.isManager()"
                         @click="addMerStaffUser(scope.row)">
                {{ $t('text.addStaffAccount') }}
              </el-button>
              <el-button type="primary" plain size="mini" @click="edit(scope.row)">
                {{ $t('text.edit') }}
              </el-button>
<!--              <el-button type="primary" plain size="mini" v-if="ROLE_TYPE.isManager()"-->
<!--                         @click="editTieredBilling(scope.row)">-->
<!--                {{ $t('text.tieredBilling') }}-->
<!--              </el-button>-->
            </template>
          </el-table-column>
        </template>
      </page>

      <MerchantEdit :show.sync="showDialog" :formData="formData" :action="action"/>
<!--      <TieredBilling :show.sync="isTieredBillingDialog" :formData="formData" :action="action"/>-->
      <BatchMerchantUpdate :show.sync="showBatchDialog" :value="strMultipleSelection" :action="action"/>
    </div>
  </div>
</template>

<script>
import Page from "@/components/Page.vue";
import MerchantEdit from "./MerchantEdit";
import TieredBilling from "./TieredBilling";
import BatchMerchantUpdate from "./BatchMerchantUpdate";
import {ROLE_TYPE} from "@/utils/Constant";
import { PaymentType } from '@/constants/paymentTypes';

export default {
  name: "Systems",
  computed: {
    ROLE_TYPE() {
      return ROLE_TYPE
    },
    setSettlementCycleList: {
      get() {
        return this.form.settlementCycleList ? this.form.settlementCycleList.split(',') : [];
      },
      set(value) {
        this.form.settlementCycleList = value.join(',');
      }
    }
  },
  components: {
    page: Page,
    MerchantEdit: MerchantEdit,
    TieredBilling: TieredBilling,
    BatchMerchantUpdate: BatchMerchantUpdate
  },

  data() {
    return {
      multipleSelection: [],
      strMultipleSelection: [],
      url: "/merchant/selectList",
      action: "",
      agentList: [],
      form: {
        agentId: "",
        showWaitSettleAmount: '01',
        settlementCycleList:"",
      },
      showDialog: false,
      showBatchDialog: false,
      formData: null,
      TieredBillingData: null,
      showSetPayDialog: false,
      showWalletInfoDialog: false,
      isTieredBillingDialog: false,
      merchantList: [],
      paymentTypes: PaymentType
    };
  },
  methods: {
    handleSelectionChange(val) {
      this.multipleSelection = val;
      this.strMultipleSelection = this.multipleSelection.map(
          ({appId}) => appId
      );
    },

    add() {
      this.action = "addMerchant";
      this.formData = null;
      this.showDialog = true;
    },

    edit(row) {
      this.action = "editMerchant";
      this.formData = JSON.parse(JSON.stringify(row));
      this.formData.availableCreditQuota = this.formData.availableCreditQuota / 100
      this.showDialog = true;
    },

    editStatus() {
      this.action = "editMerchantStatus";
      this.showBatchDialog = true;
    },

    // editTieredBilling(row) {
    //   this.$axios
    //       .get('/merchant/tieredBillingGet', {
    //         params: {
    //           appId: row.appId
    //         }
    //       })
    //       .then(res => {
    //         this.formData = res.data
    //         console.log(this.formData);
    //         this.isTieredBillingDialog = true;
    //       })
    // },
    reloadAllWaitSettleAmount() {
      this.$axios
          .get('/merchant/reloadAllWaitSettleAmount', {params: {}})
          .then(res => {
            this.$notify.success({
              title: this.$t('text.prompt').toString(),
              message: res.msg
            });
          })
    },
    resendAddMerchantMail(row) {
      this.axios.post('/merchant/resendAddMerchantMail', {
        appId: row.appId
      })
          .then(res => {
            if (res.code === 200) {
              this.$message.success(res.msg);
            } else {
              this.$message.error(res.msg);
            }
          })
    },
    resetMerPass(row) {
      this.$confirm(
          this.$t('message.confirmResettingMerchantPasswordAndGoogleAuthKey'),
          this.$t('text.prompt'),
          {
            confirmButtonText: this.$t('text.confirm'),
            cancelButtonText: this.$t('text.cancel'),
            type: 'warning',
          })
          .then(() => {
            this.$confirm(
                this.$t('message.doubleConfirmResetMerchantPasswordAndGoogleAuthKey', {name: row.merchantName}),
                this.$t('text.prompt'),
                {
                  confirmButtonText: this.$t('text.confirm'),
                  cancelButtonText: this.$t('text.cancel'),
                  type: 'info',
                })
                .then(() => {
                  this.axios.post('/merchant/resetMerPass', {
                    appId: row.appId
                  })
                      .then(res => {
                        this.$message({
                          message: res.msg,
                          type: 'success',
                        })
                      })
                })
          })
    },

    addMerStaffUser(row) {
      // this.formData = row;
      this.$confirm(
          this.$t('message.confirmAddingMerchantStaffUser', {name: row.merchantName}),
          this.$t('text.prompt'),
          {
            confirmButtonText: this.$t('text.confirm'),
            cancelButtonText: this.$t('text.cancel'),
            type: 'info',
          })
          .then(() => {
            this.axios
                .post('/merchant/addMerStaffUser', {
                  appId: row.appId
                })
                .then(res => {
                  if (res.code === 200) {
                    this.$message.success(res.msg);
                  } else {
                    this.$message.error(res.msg);
                    return false;
                  }

                  this.$bus.$emit("refresh"); //通知刷新
                  this.closeDialog();
                })
                // .then(res => {
                //   if (res.code === 500 ) {
                //     this.$message.error(this.$t('message.addMerStaffUserFailed'));
                //     return;
                //   }
                //   let filename
                //   const contentDisposition = res.headers['content-disposition'];
                //   const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
                //   const matches = filenameRegex.exec(contentDisposition);
                //   if (matches != null && matches[1]) {
                //     filename = matches[1].replace(/['"]/g, '')
                //   }
                //
                //   let blob = new Blob([res.data], {
                //     type: 'text/plain',
                //   })
                //   // 将blob对象转为一个URL
                //   const blobURL = window.URL.createObjectURL(blob);
                //   // 创建一个a标签
                //   const tempLink = document.createElement('a');
                //   // 隐藏a标签
                //   tempLink.style.display = 'none'
                //   // 设置a标签的href属性为blob对象转化的URL
                //   tempLink.href = blobURL
                //   // 给a标签添加下载属性
                //   tempLink.setAttribute('download', filename)
                //   if (typeof tempLink.download === 'undefined') {
                //     tempLink.setAttribute('target', '_blank')
                //   }
                //   // 将a标签添加到body当中
                //   document.body.appendChild(tempLink)
                //   // 启动下载
                //   tempLink.click()
                //   // 下载完毕删除a标签
                //   document.body.removeChild(tempLink)
                //   window.URL.revokeObjectURL(blobURL)
                // })
          });
    },
  },

  created() {
    if (this.ROLE_TYPE.isManager()) {
      this.$axios
          .get('/agent/selectAgentForOption', {params: {}})
          .then(res => {
            this.agentList = res.data
          })
    }
    this.$axios
        .get("/merchant/selectListForOption", {params: {}})
        .then((res) => {
          this.merchantList = res.data;
          if (this.merchantList.length === 1) {
            this.form.appId = this.merchantList[0].value;
          }
        });
  },

};
</script>

<style scoped>
</style>
